/* Barra con cuenta atrás — sin dependencias */
(function () {
  if (customElements.get('countdown-bar')) return;

  class CountdownBar extends HTMLElement {
    connectedCallback() {
      this.els = {
        days: this.querySelector('[data-days]'),
        hours: this.querySelector('[data-hours]'),
        minutes: this.querySelector('[data-minutes]'),
        seconds: this.querySelector('[data-seconds]'),
        clock: this.querySelector('.af-cd__clock'),
        expired: this.querySelector('[data-expired-text]')
      };
      if (!this.els.days) return;
      this.onExpire = this.dataset.expired || 'restart';
      this.target = this.resolveTarget();
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }

    disconnectedCallback() {
      if (this.timer) clearInterval(this.timer);
    }

    resolveTarget() {
      if (this.dataset.mode === 'fixed') {
        const t = new Date(this.dataset.end).getTime();
        return isNaN(t) ? Date.now() + 3600000 : t;
      }
      // Recurrente: se guarda por visitante
      const hours = parseFloat(this.dataset.hours) || 3;
      const key = this.dataset.key || 'af-countdown';
      let stored = null;
      try { stored = localStorage.getItem(key); } catch (e) { stored = null; }
      let target = stored ? parseInt(stored, 10) : NaN;
      if (isNaN(target) || target <= Date.now()) {
        target = Date.now() + hours * 3600000;
        try { localStorage.setItem(key, String(target)); } catch (e) {}
      }
      return target;
    }

    pad(n) { return n < 10 ? '0' + n : String(n); }

    tick() {
      let diff = this.target - Date.now();

      if (diff <= 0) {
        if (this.onExpire === 'restart') {
          try { localStorage.removeItem(this.dataset.key); } catch (e) {}
          this.target = this.resolveTarget();
          diff = this.target - Date.now();
        } else {
          if (this.timer) clearInterval(this.timer);
          if (this.onExpire === 'hide') { this.hidden = true; return; }
          if (this.els.clock) this.els.clock.hidden = true;
          if (this.els.expired) this.els.expired.hidden = false;
          return;
        }
      }

      const s = Math.floor(diff / 1000);
      this.els.days.textContent = this.pad(Math.floor(s / 86400));
      this.els.hours.textContent = this.pad(Math.floor((s % 86400) / 3600));
      this.els.minutes.textContent = this.pad(Math.floor((s % 3600) / 60));
      this.els.seconds.textContent = this.pad(s % 60);
    }
  }

  customElements.define('countdown-bar', CountdownBar);
})();
